'use client';

import React from 'react';
import { cn } from '@workspace/lib/utils';
import { ContactSupportSection } from '@workspace/blocks';

interface DocumentHubLayoutProps {
  className?: string;
  pageSlug: string;
  children: React.ReactNode;
}

export function DocumentHubLayout({ className, pageSlug, children }: DocumentHubLayoutProps) {
  return (
    <>
      <div className={cn('wrapper lg:py-3xl px-md', className)}>
        <div className="max-md:pb-lg max-md:pt-10">{children}</div>
      </div>
      <ContactSupportSection locator={{ pageType: 'documentHub', slug: pageSlug || 'document-hub' }} showError />
    </>
  );
}
